export default "__VITE_ASSET__BjB1u$mR__"